import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {contactInfo.title}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {contactInfo.subtitle}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <p className="text-sm md:text-base text-foreground-600 text-center leading-relaxed">
            {contactInfo.desc}
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex items-center gap-4 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-xl">
              <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-500 text-xl" />
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">投稿邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-xl">
              <div className="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-xl" />
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
              </div>
            </div>
          </div>

          <div className="mt-6 p-4 bg-secondary-100/50 border border-secondary-200/50 rounded-xl">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-secondary-200 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-secondary-600" />
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {contactInfo.tips}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}